const $ = jQuery;

import PropertyAjax from './ajax/propertyAjax';

class AppAjax {
    constructor() {
        // Store AJAX handlers
        this.handlers = {};
        
        // Initialize when DOM is ready
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => this.init());
        } else {
            this.init();
        }
    }

    init() {
        console.log('Initializing AppAjax...');
        this.initAjaxHandlers();
    }

    initAjaxHandlers() {
        // Initialize property AJAX handler if on property pages
        if ($('.c-container_property_list').length || $('#property-map-container').length) {
            this.handlers.propertyAjax = new PropertyAjax();
            
            // If Properties instance exists in window.app.components
            if (window.app?.components?.properties) {
                window.app.components.properties.setAjaxHandler(this.handlers.propertyAjax);
            }
        }

        // Add other AJAX handlers here as needed
        // Example:
        // if (someCondition) {
        //     this.handlers.someHandler = new SomeAjaxHandler();
        // }
    }
}

// Initialize the AJAX application
const appAjax = new AppAjax();

// Export for potential use elsewhere
export default appAjax;
